/**
 * 自動配車の通知文言。出す / 出さないの判定ごとここに置く。
 *
 * この画面の controller は D&D の自動保存（timeline）とツールバーの通常実行（normal）で
 * 共有されている。**どちらでも出す**。D&D は落としたあとサーバの自動配車が終わって初めて
 * 確定するので、進行中であることを伝えないと「落とした＝割り付いた」と読めてしまう
 * （ユーザー指摘 2026-09-29）。カード配車（Presenter.tsx:1067）と同じ扱いにする。
 *
 * Why not timeline では黙る（旧実装）: トーストが並ぶのを避けるためだったが、その代わりに
 * 落とした瞬間「{地点名} を割り付けました」を出していて、まだ割り付いていない時点で
 * 成功を言い切っていた。割り付けた結果は完了してから出す（`dropAssignNotification`）。
 *
 * 入れ替え（swap）・移動（transfer）は「自動配車」ではないので出さない。カード配車は
 * これらに専用の文言を当てており、この画面にはまだその操作が無い。
 *
 * 失敗はモードを問わず出す（黙って落とすと「保存されたつもり」になる）。
 * 文言は `/map`（mapAutoDispatchHooks.ts）に合わせる。
 */
export type AutoDispatchNotification = {
  message: string;
  variant?: 'success' | 'error';
};

/** 自動配車として扱うモード。入れ替え・移動は別の操作なので数えない */
const AUTO_DISPATCH_MODES = ['normal', 'timeline'];

/** 実行を受け付けたとき */
export function autoDispatchStartedNotification(mode: string): AutoDispatchNotification | null {
  return AUTO_DISPATCH_MODES.includes(mode) ? { message: '自動配車を実行中...' } : null;
}

/** 完了したとき。割り付かなかった案件があれば件数を出す */
export function autoDispatchCompletedNotification(
  mode: string,
  notAllocatedCount: number,
): AutoDispatchNotification | null {
  if (!AUTO_DISPATCH_MODES.includes(mode)) return null;
  if (notAllocatedCount > 0) {
    return { message: `${notAllocatedCount.toLocaleString()}件が割り当たりませんでした` };
  }
  return { message: '自動配車が完了しました', variant: 'success' };
}
